export * from '../common/panorama-tour/model/panorama-tour.event';
export * from '../common/tabs-section/model/tabs-section.event';
export * from '../common/resource-media-control/model/resource-media-control.event';
export * from '../common/smart-tags/model/smart-tags.event';

export enum GeneralEventType {
	UPDATE_DATA = 'updateData',
	DATA_UPDATED = 'dataUpdated'
}

export class BroadcastGeneralEventMetadata {
	path: string; // relative dataPoint
	data: any;
	isCreate?: boolean;
	isUpdate?: boolean;
	isReplace?: boolean;
	[attrName: string]: any;

	constructor() {
		this.isCreate = false;
		this.isUpdate = false;
		this.isReplace = false;
	}
}
